import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { redirectToSsoLogin } from '../auth'

class Login extends Component {
  UNSAFE_componentWillMount() {
    redirectToSsoLogin(this.props.returnPath)
  }

  render() {
    return null
  }
}

Login.propTypes = {
  returnPath: PropTypes.string.isRequired
}

export default Login



// WEBPACK FOOTER //
// ./src/routes/Login/Login.js